<script setup>
import { useSpotStore } from '~/store/spot'
import { time2Date } from '~/utils/tools'

import IconHistory from '~/assets/images/spot/ic-history.svg'
import IconTotal from '~/assets/images/spot/ic-profit-sharing.svg'
import IconWebsite from '~/assets/images/spot/ic-website.svg'
import IconWhitePaper from '~/assets/images/spot/ic-white-paper.svg'

const { t } = useI18n()
const spot = useSpotStore()
const detail = ref({})
const list = computed(() => {
  const { publishTime, publishTotal, officialWebsite, whitePaper } = spot.currencyIntro
  return [
    { title: t('发行时间'), key: 'publishTime', value: publishTime ? time2Date(publishTime, 'y-m-d') : '-', icon: IconHistory },
    { title: t('发行总量'), key: 'publishTotal', value: publishTotal ?? '-', icon: IconTotal },
    { title: t('白皮书'), key: 'whitePaper', value: officialWebsite ?? '-', icon: IconWhitePaper },
    { title: t('官网'), key: 'officialWebsite', value: whitePaper ?? '-', icon: IconWebsite },
  ]
})

const baseInfo = computed(() => spot.getInfo(spot.base))

watch(baseInfo, ({ id }) => {
  id && spot.getCurrencyIntro(id)
}, { immediate: true })
</script>

<template>
  <div class="px-4 py-3 text-textSecondary text-[10px]">
    <h3 class="font-bold text-textPrimary mb-[10px]">
      {{ t('币种简介') }}
    </h3>
    <div>
      {{ spot.currencyIntro.summary ?? '--' }}
    </div>
    <h3 class="font-bold text-textPrimary mb-[10px] mt-6">
      {{ t('币种参数') }}
    </h3>
    <div class="flex flex-wrap gap-x-2 gap-y-3 w-full">
      <div v-for="i in list" :key="i.key" class="h-[46px] w-[calc(50%-8px)] flex items-center bg-pageTertiary rounded-lg px-3">
        <component :is="i.icon" class="w-5 h-5 text-textPrimary" />
        <div class="ms-2 leading-[14px]">
          <p class="text-textPrimary">
            {{ i.title }}
          </p>
          <p class="text-textTertiary">
            {{ i.value }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
